import { CurrencyInrIcon, InvoiceIcon } from '@phosphor-icons/react';
import { TreasureChest } from '@phosphor-icons/react/dist/ssr';
import {
  PiChartBar,
  PiClock,
  PiForkKnife,
  PiGear,
  PiHandCoins,
  PiIdentificationCard,
  PiReceiptLight,
  PiStar,
  PiStorefront,
  PiUsers,
} from 'react-icons/pi';

export const sideBarData = [
  {
    id: 0,
    title: 'Dashboard',
    path: '/',
    icon: <PiChartBar size={24} />,
    // Lock: true,
    hasChild: false,
  },
  // {
  //   id: 9,
  //   title: 'Sales Summary',
  //   icon: <CiMoneyBill size={24} />,
  //   path: '/sales-summary',
  //   hasChild: false,
  // },
  {
    id: 7,
    title: 'Reports',
    icon: <PiClock size={24} />,
    path: '/shift',
    hasChild: true,
    child: [
      {
        id: 40,
        title: 'Item sales',
        path: '/item-sales',
      },
      {
        id: 41,
        title: 'Sales summary',
        path: '/daily-summary',
      },
    ],
  },
  // {
  //   id: 7,
  //   title: 'Shifts',
  //   icon: <PiClock size={24} />,
  //   path: '/shift',
  //       Lock: true,
  //       hasChild: false,
  //   // child: [
  //   //   {
  //   //     id: 40,
  //   //     title: 'Cash Management',
  //   //     path: '/cash',
  //   //   },
  //   //   {
  //   //     id: 41,
  //   //     title: 'Shift Reports',
  //   //     path: '/shift',
  //   //   },
  //   // ],
  // },
  // {
  //   id: 8,
  //   title: 'business',
  //   icon: <PiStar size={24} />,
  //   path: '/business',
  //   hasChild: false,
  // },
  {
    id: 2,
    title: 'Area',
    hasChild: true,
    // path: '/restaurant-tables',
    icon: <PiStorefront size={24} />,
    child: [
      {
        id: 1332,
        title: 'Areas',
        path: '/restaurant-floors',
        // Lock: true,
      },
      {
        id: 130,
        title: 'Table Management',
        path: '/restaurant-tables',
        // Lock: true,
      },
      // {
      //   id: 131,
      //   title: 'Details',
      //   path: '/restaurant-detail',
      // },
    ],
  },
  // {
  //   id: 9,
  //   title: 'hotel',
  //   hasChild: true,
  //   path: '/hotel-detail',
  //   icon: <PiStorefront size={24} />,
  //   child: [
  //     {
  //       id: 1332,
  //       title: 'Hotel',
  //       path: '/restaurant-floors',
  //       // Lock: true,
  //     },
  //     {
  //       id: 130,
  //       title: 'Table Management',
  //       path: '/restaurant-tables',
  //       // Lock: true,
  //     },
  //     {
  //       id: 131,
  //       title: 'Details',
  //       path: '/restaurant-detail',
  //     },
  //   ],
  // },
  {
    id: 1,
    title: 'Menu',
    icon: <PiForkKnife size={24} />,
    // path: '/items-list',
    hasChild: true,
    child: [
      {
        id: 10,
        title: 'Items',
        path: '/items-list',
      },
      {
        id: 15,
        title: 'Label',
        path: '/items-label',
      },
      {
        id: 12,
        title: 'Categories',
        path: '/item-categories',
      },
      {
        id: 13,
        title: 'Modifiers',
        path: '/item-modifiers',
      },
      {
        id: 14,
        title: 'Discount',
        path: '/item-discount',
      },
    ],
  },
  {
    id: 3,
    title: 'Inventory',
    icon: <TreasureChest size={24} />,
    path: '/inventory',
    hasChild: false,
  },
  {
    id: 5,
    title: 'Expenses',
    icon: <PiHandCoins size={24} />,
    path: '/expenses',
    hasChild: false,
  },
  {
    id: 8,
    title: 'Orders',
    icon: <PiReceiptLight size={24} />,
    // Lock: true,
    path: '/orders',
    hasChild: false,
  },
  // {
  //   id: 5,
  //   title: 'Receipt',
  //   icon: <PiNote size={24} />,
  //   path: '/receipt',
  //   Lock: true,
  //   hasChild: false,
  // },
  {
    id: 3,
    title: 'Customers',
    icon: <PiUsers size={24} />,
    path: '/customers',
    hasChild: false,
  },
  {
    id: 8,
    title: 'Feedbacks',
    icon: <PiStar size={24} />,
    path: '/feedbacks',
    hasChild: false,
  },
  {
    id: 4,
    title: 'Employee',
    icon: <PiIdentificationCard size={24} />,
    // path: '/employee-list',
    Lock: true,
    hasChild: true,
    child: [
      {
        id: 30,
        title: 'Employee List',
        // Lock: true,
        path: '/employee-list',
      },
      {
        id: 31,
        title: 'Designation',
        // Lock: true,
        path: '/designation',
      },
    ],
  },
  {
    id: 'billing',
    title: 'billing',
    icon: <CurrencyInrIcon size={24} />,
    path: '/billing',
    hasChild: false,
  },
  {
    id: 6,
    title: 'settings',
    icon: <PiGear size={24} />,
    path: '/settings',
    hasChild: false,
  },
];
